var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-stream",style:(_vm.customStyle)},[_c('div',{staticClass:"md-render",domProps:{"innerHTML":_vm._s(_vm.renderedHtml)}}),(_vm.showCursor && !_vm.isFinish)?_c('span',{staticClass:"cursor"},[_vm._v("|")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }